/* Home view */
import React, { lazy } from "react";
import { BrowserRouter, Switch, Redirect } from "react-router-dom";
import { Route, LazyRoute } from "seed/helpers";
import StyleColor from "components/util/helpers/StyleColor"
import Presentation from "components/presentation/Presentation";
import { HOST_SHELL_PATHS } from "components/util/host_routes";
import { ComposeProvider } from "components/util/helpers/providers/ComposeProvider";
import { AuthProvider } from "components/util/helpers/providers/AuthProvider";
import { PermissionProvider } from "components/util/helpers/providers/PermissionsProvider";
import { ThemeProvider } from "components/util/helpers/providers/ThemeProvider";
import ShellRedirect from "components/Home.sub.ShellRedirect.view";

const Settings = lazy(() => import("components/tmisc/settings/Settings"));
const Organizations = lazy(() => import("components/tmisc/organizations/Organizations"));
const AuthHandler = lazy(() => import("components/util/schema_form/fields/account_picker/AuthHandler"));


// `basename` is the mount point of the project's route space. It is /app for the app
// itself and the embed's own path for a flow being framed by a host page, and it has to
// reach the router because everything under it — the flow token that opens a project, and
// the app's own routes — is read relative to it.
const HomeView = ({ basename = "/app", isEmbedded = false }) =>
  <BrowserRouter basename={basename}>
    <ComposeProvider 
      providers={[
        AuthProvider,
        PermissionProvider,
        ThemeProvider,
      ]}>
      {/* Background default init */}
      <Switch>
        {/* The dashboards are full-bleed: the hero would run behind their header */}
        <Route path={["/settings/governance", "/settings/activity"]}
          component={() => <StyleColor backgroundHeight="30vh" />} />
        <Route path={["/home", "/settings", "/organizations"]}
          component={() => <StyleColor backgroundHeight="45vh" />} />
        <Route path="/" component={() => <StyleColor backgroundHeight="0vh" />} />
      </Switch>

      {/* Home routes */}
      <div>
        <main id="content" role="main">
          <Switch>
            <LazyRoute path="/settings/auth" component={AuthHandler} />
            <LazyRoute path="/settings" component={Settings} />
            <LazyRoute path="/organizations" component={Organizations} />
            {/* What a project's navigate("/logout") lands on: /app/logout */}
            <Route path={HOST_SHELL_PATHS} component={ShellRedirect} />
            {/* Everything else under /app is the project app's route space, and the
                app's own router matches it. */}
            <Route path={"/"} render={() => <Presentation isEmbedded={isEmbedded} />} />
          </Switch>
        </main>
      </div>
    </ComposeProvider>
  </BrowserRouter>;

export default HomeView;